import { EmeraldDialogTypes } from '../common/enumerations/emerald-dialog-types';
import { EmeraldErrorModal } from '../common/api/emerald-error';
import { MessageModalSizeEnum } from '../common/interfaces/dtos/IMessageModal';

export const handleQuantityNotAllowedModal = (): EmeraldErrorModal => {
  return new EmeraldErrorModal({
    title: 'OnlineItemQuantity_Title',
    message: 'OnlineItemQuantity_Message',
    subMessage: 'OnlineItemQuantity_Sub_Message',
    type: EmeraldDialogTypes.Info,
    size: MessageModalSizeEnum.Medium,
    acceptButtonLabel: 'Ok',
    hideCancelButton: true,
    dialogHeight: 47.8,
  });
};
